APP.carChoose = function (cb) {
	const el = $('.car-choose');
	const slickCarChoose = el.find('.slick--car-choose');

	function init() {
		if (el.length === 0) return;

		APP.getData(`${api}/wp/model/slider`, function (data) {
			if (data?.result === 'success') {
				renderModelItemToDom(data?.items);
			}
		});
	}

	function renderModelItem(model) {
		return `<div class="slick__item">
		<div class="car-choose__item">
			<div class="car-choose__bg">
				<div class="car-choose__inner"></div>
			</div>
			<div class="car-choose__main">
				<div class="car-choose__selected">${_lang === 'en' ? 'Picked' : 'Đã chọn'}</div>
				<div class="car-choose__thumb">
					<img class="img img--full" src="${model?.image}">
				</div>
				<div class="car-choose__body">
					<h2 class="title title--5" data-model-id="${model?.car_model?.term_id}" data-model-tag="${
			model?.model_name
		}">${model?.model_name}</h2>
					<div class="body-copy">
						<p>${model?.price}</p>
					</div>
				</div>
			</div>
		</div>
	</div>`;
	}

	function renderModelItemToDom(modelItems) {
		const items = modelItems.map((item) => renderModelItem(item));
		slickCarChoose.html(items);

		cb();

		// slickCarChoose.slick({
		// 	infinite: true,
		// 	centerMode: true,
		// 	centerPadding: '180px',
		// 	slidesToShow: 3,
		// 	slidesToScroll: 3,
		// 	responsive: [
		// 		{
		// 			breakpoint: 992,
		// 			settings: {
		// 				arrows: false,
		// 				infinite: true,
		// 				centerMode: true,
		// 				centerPadding: '60px',
		// 				slidesToShow: 1,
		// 				slidesToScroll: 1,
		// 			},
		// 		},
		// 	],
		// });

		// slickCarChoose.on('swipe', handleCarChoose);

		// slickCarChoose.on('click', '.slick-active', onClickSlickItem);
	}

	// function onClickSlickItem(e) {
	// 	e.stopPropagation();
	// 	const index = $(this).data('slick-index');
	// 	slickCarChoose.slick('slickGoTo', index);
	// 	handleCarChoose();
	// }

	// function handleCarChoose() {
	// 	const slickSlide = slickCarChoose.find('.slick-slide');
	// 	const formGroup = slickCarChoose.next();
	// 	const formError = formGroup.find('.form__error');
	// 	const slickActiveCenter = slickCarChoose.find('.slick-active.slick-center');
	// 	const title = slickActiveCenter.find('.title');
	// 	const modelIdValue = parseInt(title.data('model-id'));
	// 	const modelNameValue = title.text();

	// 	slickSlide.removeClass(CLASS._selected);
	// 	slickActiveCenter.addClass(CLASS._selected);
	// 	formGroup.removeClass(CLASS._error).removeClass(CLASS._focus);
	// 	formError.text('');
	// 	modelId.val(modelIdValue);
	// 	modelName.val(modelNameValue);

	// 	APP.getData(`${api}/wp/variant?model_id=${modelIdValue}`, function (items) {
	// 		renderVariantList(items);
	// 	});

	// 	$('.car-degrees').removeClass(CLASS._active);
	// 	$(`.car-degrees[data-model-id="${modelIdValue}"]`).addClass(CLASS._active);
	// }

	init();
};
